var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import AlertCard from '@/components/alert-card/AlertCard';
import AreaRow from '@/components/area-row/AreaRow';
import AsyncSelect from '@/components/async-select/AsyncSelect';
import DataTable from '@/components/data-table/DataTable';
import LoaderCard from '@/components/loader-card/LoaderCard';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { Curriculum } from '@/models/Curriculum';
import { Event as EventModel } from '@/models/Event';
import { LessonType } from '@/models/LessonType';
import { Student } from '@/models/Student';
import { Subject } from '@/models/Subject';
import ErrorHandler from '@/support/ErrorHandler';
import { lessonTypeIcons, whiteAreaIcons, whiteKidIcons } from '@/support/Icon';
import Storage from '@/support/Storage';
import { avatarHtml, replaceUrlsWithAnchorTags } from '@/support/String';
import { DateTime } from 'luxon';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import SubjectSearchDialog from '@/views/Users/Teacher/SubjectSearchDialog';
let RosterEditDialog = class RosterEditDialog extends Vue {
    constructor() {
        // GETTERS
        super(...arguments);
        this.activeStudents = [];
        this.areas = [];
        this.curriculum = new Curriculum();
        this.detailedEvent = null;
        this.finishedStudents = [];
        this.invitations = {};
        this.lessonTypeIcons = null;
        this.lessonTypes = null;
        this.notInClassActiveStudents = [];
        this.notInPlpStudents = [];
        this.selectedLessonType = null;
        this.totalStudents = [];
        this.currentStep = 1;
        this.description = '';
        this.parsedDescription = '';
        this.clearSelects = false;
        this.isLoading = true;
        this.isLoadingLessonType = true;
        this.showSubjectSearchDialog = false;
        this.rules = {
            counter: (value) => {
                return value.length <= 250 || 'Max 250 characters';
            },
        };
        this.userSubjects = {
            rows: [],
            totals: {
                finished: 0,
                unfinished: 0,
            },
        };
        this.filters = {
            periods: [],
            levels: [],
            subject_labels: [],
        };
        this.checkboxes = {
            inviteCompleted: false,
            inviteNotInClassActive: false,
            inviteNotInPlP: false,
        };
        //   @Watch('currentStep')
        //   public currentStepChanged(currentStep: number, previousStep: number) {
        //     if (!this.detailedEvent) {
        //       return;
        //     }
        //     // if (this.currentStep === 1 && currentStep !== previousStep) {
        //     //   this.initializeCurriculumStep();
        //     //   return;
        //     // }
        //     // if (this.currentStep > 2) {
        //     //   this.initializeOverviewStep();
        //     //   return;
        //     // }
        //     // if (this.currentStep > 2 && previousStep < 2) {
        //     //   this.initializeOverviewStep();
        //     //   return;
        //     // }
        //     // if (this.currentStep === 3) {
        //     //   this.initializeOverviewStep();
        //     //   return;
        //     // }
        //   }
    }
    get parsedDescriptionText() {
        if (this.detailedEvent && this.detailedEvent.description) {
            return replaceUrlsWithAnchorTags(this.detailedEvent.description);
        }
        return '';
    }
    get whiteIcons() {
        const type = Storage.get('type');
        return type && type.toLowerCase() === 'po' ? whiteAreaIcons : whiteKidIcons;
    }
    get tableOptions() {
        return {
            name: {
                singular: 'Student',
                plural: 'Students',
            },
            headers: [
                {
                    text: '',
                    value: 'avatar',
                    transform: avatarHtml,
                },
                {
                    text: this.$t('name.title'),
                    value: 'name',
                },
            ],
            actions: [],
            filters: [],
            dropdown: [],
            model: new Student(),
        };
    }
    get visibleStudents() {
        const visibleStudents = this.$store.state.settings.find((setting) => setting.key === 'visibility_date_students');
        return visibleStudents;
    }
    get isBeforeVisibleStudent() {
        if (this.event && this.event.starts_at && this.visibleStudents) {
            const eventStart = DateTime.fromFormat(this.event.starts_at, 'dd-LL-yyyy HH:mm').toFormat('yyyy-LL-dd');
            if (eventStart <= this.visibleStudents.value) {
                return true;
            }
        }
        return false;
    }
    get curriculumFilters() {
        const filter = {};
        Object.keys(this.filters).forEach((key) => {
            if (this.filters[key].length === 0) {
                return;
            }
            filter[key] = this.filters[key];
        });
        return filter;
    }
    get selectedSubjects() {
        if (!this.$store.state.selected) {
            return [];
        }
        const invitations = {};
        this.$store.state.selected.forEach((subject) => {
            if (subject.id && !invitations[subject.id]) {
                invitations[subject.id] = {
                    active: {
                        is_invited: false,
                        is_mandatory: false,
                    },
                    finished: {
                        is_invited: false,
                        is_mandatory: false,
                    },
                    other: {
                        is_invited: false,
                        is_mandatory: false,
                    },
                };
            }
        });
        this.invitations = { ...this.invitations, ...invitations };
        return this.$store.state.selected || [];
    }
    mounted() {
        this.lessonTypeIcons = lessonTypeIcons;
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        this.currentStep = 1;
        this.areas = [];
        await this.fetchEvent();
        if (this.detailedEvent && this.detailedEvent.lesson_type) {
            this.selectedLessonType = new LessonType(this.detailedEvent.lesson_type);
        }
        this.fillSelectFilter();
        this.setVolitionCheckboxes();
        if (this.hardlocked || (this.detailedEvent && this.detailedEvent.subjects && this.detailedEvent.subjects.length)) {
            this.currentStep = 3;
        }
        else {
            if (!this.filters.levels.length && !this.filters.periods.length) {
                await this.initializeCurriculumStep();
            }
        }
        this.isLoading = false;
    }
    async getSubjects(extendedFilters = {}) {
        extendedFilters.curriculum = this.curriculum.id;
        if (this.detailedEvent && this.detailedEvent.subjects) {
            const areas = [];
            this.detailedEvent.subjects.forEach((subject) => {
                if (subject.id && subject.depth === 0) {
                    areas.push(subject.id);
                }
            });
            extendedFilters.areas = areas;
        }
        Object.keys(this.filters).forEach((key) => {
            if (this.filters[key] === null || this.filters[key].length === 0) {
                return;
            }
            extendedFilters[key] = this.filters[key];
        });
        new Subject()
            .filter(extendedFilters)
            .include('children')
            .limit(100)
            .all()
            .then((subjects) => {
            if (!subjects) {
                return;
            }
            if (!this.detailedEvent) {
                this.areas = subjects;
            }
            else {
                this.areas = this.sortByEventArea(subjects);
            }
            this.curriculum.subjects = subjects;
        });
        if (this.detailedEvent && (this.detailedEvent.updated_at !== this.detailedEvent.created_at)) {
            this.setSelectedSubjects();
        }
        // preload Lesson Types
        this.initializeLessonTypeStep();
        this.isLoading = false;
    }
    close() {
        this.$emit('input', false);
        this.$emit('dialogClosed', true);
        this.currentStep = 1;
        this.clearSelects = false;
    }
    clear() {
        this.$store.dispatch('selectedChanged', null);
        this.$store.dispatch('checkboxReset', true);
        this.detailedEvent = null;
        this.selectedLessonType = null;
        this.clearSelects = true;
        this.$nextTick(() => {
            this.close();
        });
    }
    initializeOverviewStep() {
        if (this.detailedEvent && this.currentStep === 2 && this.selectedSubjects.length) {
            this.detailedEvent.subjects = this.selectedSubjects;
        }
        if (this.detailedEvent && this.detailedEvent.subjects && this.detailedEvent.subjects.length) {
            this.$store.dispatch('selectedChanged', this.detailedEvent.subjects);
        }
        this.resetSelectedSubjects();
        this.resetCalculation();
        if (!this.curriculum.id) {
            this.initializeCurriculumStep();
        }
        if (!this.lessonTypes) {
            this.initializeLessonTypeStep();
        }
    }
    eventChanged(event) {
        this.initialize();
    }
    async lessonType(lessonType) {
        this.isLoadingLessonType = true;
        await this.fetchLessonType(lessonType);
        this.isLoadingLessonType = false;
    }
    // ASYNC
    async fetchEvent() {
        const event = await new EventModel()
            .include(['areas', 'topics', 'levels', 'groups', 'users', 'roles', 'meta', 'subjects', 'parent', 'lesson_type'])
            .find(this.event.id)
            .catch((error) => { this.isLoading = false; });
        if (!event) {
            // console.log('Event not found on RosterEditDialog.ts - fetchEvent');
            return;
        }
        this.detailedEvent = event;
    }
    async fetchSubjects() {
        const event = await new EventModel()
            .include(['subjects'])
            .find(this.event.id);
        if (this.detailedEvent && event.subjects) {
            this.detailedEvent.subjects = event.subjects;
        }
        if (this.currentStep === 2) {
            this.initializeOverviewStep();
        }
    }
    async fetchLessonType(id) {
        if (typeof id !== 'string') {
            return;
        }
        new LessonType()
            .find(id)
            .then((lessonType) => {
            this.selectedLessonType = lessonType;
            this.isLoadingLessonType = false;
        });
    }
    async initializeLessonTypeStep() {
        new LessonType()
            .all()
            .then((types) => {
            this.lessonTypes = types;
        });
    }
    async initializeCurriculumStep() {
        const curriculum = await new Curriculum()
            .current()
            .filter(this.curriculumFilters)
            .first();
        this.curriculum = curriculum;
        if (curriculum.id) {
            await this.getSubjects(this.curriculumFilters);
        }
    }
    async update() {
        if (this.isBeforeVisibleStudent) {
            return;
        }
        let callCount = 2;
        const subjects = this.selectedSubjects.map((subject) => {
            return subject.id;
        });
        let existingSubjects = [];
        if (this.detailedEvent && this.detailedEvent.areas) {
            existingSubjects = this.detailedEvent.areas.map((subject) => {
                return subject.id;
            });
        }
        let existingTopics = [];
        if (this.detailedEvent && this.detailedEvent.topics) {
            existingTopics = this.detailedEvent.topics.map((subject) => {
                return subject.id;
            });
        }
        new EventModel()
            .attachSubjectsToEvent(this.detailedEvent.id || '', [...existingSubjects, ...subjects, ...existingTopics])
            .then(() => {
            callCount -= 1;
            if (callCount <= 0) {
                this.currentStep = 4;
                this.$emit('eventEditted');
            }
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
        new EventModel({ id: this.detailedEvent.id })
            .update({
            description: this.detailedEvent ? this.detailedEvent.description : '',
            lesson_type: this.detailedEvent && this.detailedEvent.lesson_type ? this.selectedLessonType ? this.selectedLessonType.id : this.detailedEvent.lesson_type.id : '',
            is_volitional_subjects_finished: this.checkboxes.inviteCompleted,
            is_volitional_subjects_unknown: this.checkboxes.inviteNotInPlP,
            is_volitional_subjects_active: this.checkboxes.inviteNotInClassActive,
            preserve_attending_students: true,
        })
            .then(() => {
            callCount -= 1;
            if (callCount <= 0) {
                this.currentStep = 4;
                this.$emit('eventEditted');
            }
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    // CLASS METHODS
    fillSelectFilter() {
        if (this.detailedEvent && this.detailedEvent.levels && this.detailedEvent.levels.length) {
            this.filters.levels = this.detailedEvent.levels
                .map((level) => level.id || '')
                .filter(Boolean);
        }
        if (this.$store.state.period.id) {
            this.filters.periods.push(this.$store.state.period.id);
        }
    }
    resetCalculation() {
        this.totalStudents = [];
        this.activeStudents = [];
        this.finishedStudents = [];
        this.notInPlpStudents = [];
        this.notInClassActiveStudents = [];
    }
    sortByEventArea(subjects) {
        if (!this.detailedEvent || !this.detailedEvent.areas) {
            return subjects;
        }
        const areaIds = this.detailedEvent.areas.map((area) => {
            return area.id;
        });
        const selectedAreas = subjects.filter((subject) => {
            return areaIds.includes(subject.id);
        });
        const remainingAreas = subjects.filter((subject) => {
            return !areaIds.includes(subject.id);
        });
        return [...selectedAreas, ...remainingAreas];
    }
    setSelectedSubjects() {
        if (!this.detailedEvent) {
            return;
        }
        this.$store.dispatch('selectedChanged', this.detailedEvent.subjects);
    }
    deleteSubjectRow(subjectIndex) {
        this.selectedSubjects.splice(subjectIndex, 1);
        this.detailedEvent && this.detailedEvent.subjects ? this.detailedEvent.subjects.splice(subjectIndex, 1) : null;
        this.activeStudents = [];
        this.finishedStudents = [];
        this.notInPlpStudents = [];
        this.notInClassActiveStudents = [];
        this.setColumnTotals();
    }
    lessonTypeIcon(iconName) {
        return this.lessonTypeIcons[iconName];
    }
    resetSelectedSubjects() {
        this.selectedSubjects.forEach((selectedSubject) => {
            selectedSubject ? selectedSubject.busy = [] : null;
            selectedSubject ? selectedSubject.highlighted = [] : null;
            selectedSubject ? selectedSubject.old = [] : null;
            selectedSubject ? selectedSubject.not_in_plp = [] : null;
            selectedSubject ? selectedSubject.finished = [] : null;
            selectedSubject ? selectedSubject.extra_highlighted = [] : null;
            selectedSubject ? selectedSubject.extra_busy = [] : null;
            selectedSubject ? selectedSubject.extra_old = [] : null;
        });
    }
    filtersChanged(newValue, oldValue) {
        this.isLoading = true;
        this.areas = [];
        this.initializeCurriculumStep();
    }
    setVolitionCheckboxes() {
        if (!this.detailedEvent) {
            return;
        }
        this.checkboxes.inviteCompleted = this.detailedEvent.is_volitional_subjects_finished || false;
        this.checkboxes.inviteNotInClassActive = this.detailedEvent.is_volitional_subjects_active || false;
        this.checkboxes.inviteNotInPlP = this.detailedEvent.is_volitional_subjects_unknown || false;
    }
    getUniqueStudentsForStatus(newStudents, statuses, subjectStatus) {
        const currentStudents = statuses[subjectStatus] ? statuses[subjectStatus] : [];
        currentStudents.forEach((student) => {
            const isDuplicateStudent = newStudents.findIndex((findStudent) => {
                const foundStudent = student.id.toString() === findStudent.id.toString();
                return foundStudent;
            }) !== -1;
            if (isDuplicateStudent) {
                return;
            }
            if (subjectStatus === 'finished') {
                const isInActiveStudents = this.activeStudents.findIndex((activeStudent) => {
                    return activeStudent.id === student.id;
                }) !== -1;
                if (isInActiveStudents) {
                    return;
                }
            }
            if (subjectStatus === 'not_in_plp') {
                const isInActiveStudents = [...this.activeStudents, ...this.finishedStudents].findIndex((activeStudent) => {
                    return activeStudent.id === student.id;
                }) !== -1;
                if (isInActiveStudents) {
                    return;
                }
            }
            newStudents.push(student);
        });
        return newStudents;
    }
    setColumnTotals() {
        // add statuses from each row into column arrays for total
        this.selectedSubjects.forEach((subject) => {
            if (subject.highlighted) {
                this.activeStudents = this.getUniqueStudentsForStatus(this.activeStudents, subject, 'highlighted');
            }
            if (subject.busy) {
                this.activeStudents = this.getUniqueStudentsForStatus(this.activeStudents, subject, 'busy');
            }
            if (subject.old) {
                this.activeStudents = this.getUniqueStudentsForStatus(this.activeStudents, subject, 'old');
            }
        });
        this.selectedSubjects.forEach((subject) => {
            if (subject.finished) {
                this.finishedStudents = this.getUniqueStudentsForStatus(this.finishedStudents, subject, 'finished');
            }
        });
        this.selectedSubjects.forEach((subject) => {
            if (subject.not_in_plp) {
                this.notInPlpStudents = this.getUniqueStudentsForStatus(this.notInPlpStudents, subject, 'not_in_plp');
            }
        });
        this.selectedSubjects.forEach((subject) => {
            if (subject.extra_highlighted) {
                this.notInClassActiveStudents = this.getUniqueStudentsForStatus(this.notInClassActiveStudents, subject, 'extra_highlighted');
            }
            if (subject.extra_busy) {
                this.notInClassActiveStudents = this.getUniqueStudentsForStatus(this.notInClassActiveStudents, subject, 'extra_busy');
            }
            if (subject.extra_old) {
                this.notInClassActiveStudents = this.getUniqueStudentsForStatus(this.notInClassActiveStudents, subject, 'extra_old');
            }
        });
    }
};
__decorate([
    Prop({ default: null }),
    __metadata("design:type", typeof (_a = typeof EventModel !== "undefined" && EventModel) === "function" ? _a : Object)
], RosterEditDialog.prototype, "event", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], RosterEditDialog.prototype, "hardlocked", void 0);
__decorate([
    Watch('event'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_b = typeof EventModel !== "undefined" && EventModel) === "function" ? _b : Object]),
    __metadata("design:returntype", void 0)
], RosterEditDialog.prototype, "eventChanged", null);
__decorate([
    Watch('detailedEvent.lesson_type'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Promise)
], RosterEditDialog.prototype, "lessonType", null);
__decorate([
    Watch('filters', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], RosterEditDialog.prototype, "filtersChanged", null);
RosterEditDialog = __decorate([
    Component({
        components: {
            AsyncSelect,
            SelectFilter,
            LoaderCard,
            DataTable,
            AreaRow,
            AlertCard,
            SubjectSearchDialog,
        },
        filters: {
            formatDay(date) {
                return DateTime.fromSQL(date).toFormat('c');
            },
            formatTime(time) {
                return !time ? '' : DateTime.fromFormat(time, 'yyyy-LL-dd HH:mm:ss').toFormat('HH:mm');
            },
            formatDate(date) {
                return !date ? '' : DateTime.fromFormat(date, 'yyyy-LL-dd HH:mm:ss').toFormat('dd-LL-yyyy');
            },
        },
    })
], RosterEditDialog);
export default RosterEditDialog;
